import React from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import Subtitle from "../../subtitle";
import Text from "../../text";

interface LoginSelectProps {
  label?: string;
  value?: string;
  placeholder?: string;
  errorMessage?: string;
  onOpenOptions?: () => void;
}

const LoginSelect: React.FC<LoginSelectProps> = ({
  label,
  value,
  placeholder = "Selecione seu prestador",
  errorMessage,
  onOpenOptions
}) => {
  return (
    <div className="flex flex-col w-full gap-1">
      {label && (
        <Subtitle className="!text-[.85rem] !font-semibold !mb-1">
          {label}
        </Subtitle>
      )}

      <button
        type="button"
        onClick={onOpenOptions}
        className={`
          w-full
          flex
          items-center
          justify-between
          bg-[#ECF1F6]
          text-[#001120]
          text-[.85rem]
          px-[10px]
          py-[8px]
          rounded-[4px]
          border
          border-solid
          ${errorMessage ? "border-red-500" : "border-gray-300"}
          font-light
          cursor-pointer
          hover:bg-[#E6ECF3]
          transition-colors
        `}
      >
        <Text className={`!text-[.85rem] ${!value ? "!text-gray-400 !font-light " : ""}`}>
          {value || placeholder}
        </Text>

        <MdKeyboardArrowDown size={18} className="text-gray-500" />
      </button>

      {/* <div
        className={`text-[10px] text-red-500 transition-all duration-300 overflow-hidden ${
          errorMessage ? "max-h-[20px]" : "max-h-0"
        }`}
      >
        {errorMessage}
      </div> */}
    </div>
  );
};

export default LoginSelect;
